export default __webpack_public_path__ + "static/viture_one_neckband-ff6102b4f62dca4e01dae9702fed5c5d.png";